import { Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing';
import { MonitorComponent } from './components/monitor/monitor';
import { TermsComponent } from './components/terms/terms';
import { PrivacyComponent } from './components/privacy/privacy';

export const routes: Routes = [
    { path: '', component: LandingComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'monitor/:roomId', component: MonitorComponent },
    { path: '**', redirectTo: '' }
];
